/* スターターセットLP: タブ切り替え（予算で選ぶ など）
 *
 * バナーの開閉と違い、商品は常に見えている。押した瞬間に中身が入れ替わる。
 * パネルに data-src があれば、そのタブを初めて開いたときに取得して差し込む
 * （アコーディオンと同じ「1コレクション＋タグURL」の仕組み）。
 */
(function () {
  'use strict';
  /* 同じスクリプトを複数セクションが読み込むため <script> は何本も出力される。
     ブラウザはタグごとに実行するので、ガードが無いと処理が重複する。 */
  if (window.mdlLpTabsReady) return;
  window.mdlLpTabsReady = true;

  function panelsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.mdl-lp-tabs__panel'));
  }

  function buttonsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.mdl-lp-tabs__btn'));
  }

  /** data-src の中身を1回だけ取りに行く */
  function loadRemote(panel) {
    var url = panel.getAttribute('data-src');
    if (!url || panel.dataset.loaded === 'true' || panel.dataset.loading === 'true') return;
    panel.dataset.loading = 'true';
    if (!panel.innerHTML.trim()) {
      panel.innerHTML = '<p class="mdl-lp__empty">読み込み中…</p>';
    }
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + joiner + 'view=mdl-lp-grid', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        panel.innerHTML = html;
        trim(panel, url);
        panel.dataset.loaded = 'true';
      })
      .catch(function () {
        panel.innerHTML = '<p class="mdl-lp__empty">商品を読み込めませんでした。時間をおいてお試しください。</p>';
        panel.dataset.loaded = 'true';
      })
      .then(function () { panel.dataset.loading = 'false'; });
  }

  /** 表示件数まで絞り、必要なら「もっと見る」を足す。
   *  取得元のテンプレートは多めに返すので、間引きはここで行う
   *  （同じテンプレートを絞り込み結果でも使っており、件数の要件が違うため） */
  function trim(panel, url) {
    var limit = parseInt(panel.getAttribute('data-limit'), 10);
    var list = panel.querySelector('ul');
    if (list && limit > 0) {
      var items = Array.prototype.slice.call(list.children).filter(function (el) {
        return el.tagName === 'LI' && !el.classList.contains('rows-divider');
      });
      var removed = items.length - limit;
      items.slice(limit).forEach(function (el) { el.remove(); });
      if (removed <= 0) return;   // 全部収まったなら「もっと見る」は出さない
    }

    if (panel.getAttribute('data-more') !== 'true' || !url) return;
    if (panel.querySelector('.btn-more')) return;

    var link = document.createElement('a');
    link.className = 'btn-more';
    link.href = url;
    link.appendChild(document.createTextNode('もっと見る'));
    var label = panel.getAttribute('data-more-label');
    if (label) {
      var sr = document.createElement('span');
      sr.className = 'visually-hidden';
      sr.textContent = '：' + label;
      link.appendChild(sr);
    }
    link.insertAdjacentHTML('beforeend',
      '<svg class="btn-more__chevron" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>');
    panel.appendChild(link);
  }

  function activate(root, btn) {
    var target = btn.getAttribute('aria-controls');
    buttonsOf(root).forEach(function (b) {
      b.setAttribute('aria-selected', String(b === btn));
    });
    panelsOf(root).forEach(function (p) {
      var show = p.id === target;
      p.hidden = !show;
      if (show) loadRemote(p);
    });
  }

  function init(root) {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    var btns = buttonsOf(root);
    if (!btns.length) return;

    // 最初のタブの中身は先に取りに行く（押す前に見えている必要があるため）
    var first = panelsOf(root).filter(function (p) { return !p.hidden; })[0];
    if (first) loadRemote(first);

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('.mdl-lp-tabs__btn');
      if (!btn || !root.contains(btn)) return;
      activate(root, btn);
    });

    // 左右キーでタブを移動できるようにする
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var current = document.activeElement;
      if (!current || !current.classList.contains('mdl-lp-tabs__btn')) return;
      var list = buttonsOf(root);
      var i = list.indexOf(current);
      if (i === -1) return;
      var next = event.key === 'ArrowRight' ? list[i + 1] || list[0] : list[i - 1] || list[list.length - 1];
      next.focus();
      activate(root, next);
      event.preventDefault();
    });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mdl-lp-tabs]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // テーマエディタの再描画に追従する
  document.addEventListener('shopify:section:load', boot);
})();
